import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import {loadProcessToken } from "../actions/index";

export const LOAD_DIGITAL_TWIN = "LOAD_DIGITAL_TWIN";
export const CREATE_DIGITAL_TWIN = "CREATE_DIGITAL_TWIN";
export const CREATE_TWIN_COMPONENT = "CREATE_TWIN_COMPONENT";
export const UPDATE_TWIN_COMPONENT = "UPDATE_TWIN_COMPONENT";
export const DELETE_TWIN_COMPONENT = "DELETE_TWIN_COMPONENT";
export const OPEN_TWIN_COMPONENT = "OPEN_TWIN_COMPONENT";

export const loadDigitalTwin  = (selected_project, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log(selected_project);
        var url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/digitaltwin?project='+selected_project.name + '&storage_type='+ selected_project.storageType+ '&data_type='+ selected_project.dataType;
        console.log(url);
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_DIGITAL_TWIN,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in loading asset configuration');
        });
    }
}

export const createDigitalTwin = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("posting generator config");
        console.log(props);
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/digitaltwin', props).then(({ data }) => {
            toastr.success('Ready to create asset components now!');
             dispatch({
                type: CREATE_DIGITAL_TWIN,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in creating asset.');
        });
    };
}

export const createTwinComponent= (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("posting generator config");
        console.log(props);
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/digitaltwin/component', props).then(({ data }) => {
            toastr.success('Successfully created the asset component');
             dispatch({
                type: CREATE_TWIN_COMPONENT,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in creating the asset component');
        });
    };
}

export const updateTwinComponent= (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("posting twin config");
        console.log(props);
        axios.put(config.PROJECT_DASHBOARD_API_URL + 'aiservice/digitaltwin/component', props).then(({ data }) => {
            toastr.success('Successfully updated the asset component');
             dispatch({
                type: UPDATE_TWIN_COMPONENT,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in updating the asset component.');
        });
    };
}

export const deleteTwinComponent = (selected_project, selected_component, scope) => {
  let token = loadProcessToken();
  return (dispatch, getState) => {
    let encodeUrl = config.PROJECT_DASHBOARD_API_URL + "aiservice/digitaltwin/component?project="+ selected_project.name + "&storage_type="+ selected_project.storageType + "&data_type=" + selected_project.dataType + "&name=" + selected_component.name;
    console.log(encodeUrl);
    axios.delete(encodeUrl).then(({ data }) => {
        dispatch({
          type: DELETE_TWIN_COMPONENT,
          payload: data
        });
        toastr.success("Successfully deleted the asset component");
    })
    .catch(function(error) {
        toastr.error("Failed to delete asset component");
    });
  }
}


export const openTwinComponent = (twincmp) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        dispatch({
            type: OPEN_TWIN_COMPONENT,
            payload: twincmp
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/digitaltwin.js